export const sendSegment = async (eventName, params, State = 'Success') => {
  const urlParams = new URLSearchParams(window.location.search);
  const source = urlParams.get('source');

  const userInfo = JSON.parse(localStorage.getItem('userInfo'))?.user;
  const dataToSend = {
    Email: userInfo?.emails[0]?.address,
    Source: source === 'sllrapp' ? 'Mobile' : 'Dashboard',
    'Business ID': userInfo?.businessAdminInfo?.businessId || null,
    'Business Name': userInfo?.businessAdminInfo?.businessName,
    'Dashboard Source': 'Sllr_DB',
    State,
    'Last Open Date': Date.now(),
    ...params
  };
  window.analytics && (await window.analytics.track(eventName, dataToSend));
};
